<div class="menu-mobile">
  <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">

    <mat-nested-tree-node *matTreeNodeDef="let node">
      <li class="mat-tree-node">
        <a class="notChild"
           [ngClass]="{'active': isActive(node)}"
           [routerLink]="[node.link]">
          <nb-icon [icon]="node.icon"/>
          @if (node.level) {
            <span>{{ node.title }}</span>
          }
        </a>
      </li>
    </mat-nested-tree-node>

    <mat-nested-tree-node *matTreeNodeDef="let node; when: rootLevel">
      <li (mouseenter)="treeControl.toggle(node)"
          (mouseleave)="treeControl.toggle(node); hideAll = false">

        <div class="mat-tree-node"
             [ngClass]="{'active': isActive(node)}">

          @if (node.level) {
            <p>{{ node.title }}</p>
          }

          <button [attr.aria-label]="node.title"
                  nbButton
                  status="control"
                  [routerLink]="node.link ? [node.link] : null">
            <nb-icon [icon]="node.icon"/>
          </button>
        </div>

        @if (node.children?.length) {
          <ul class="nav-menu-mobile" [hidden]="!treeControl.isExpanded(node) || hideAll">
            <li class="header">{{ node.title }}</li>
            <ng-container matTreeNodeOutlet/>
          </ul>
        }
      </li>
    </mat-nested-tree-node>

  </mat-tree>
</div>
